import React from "react";

// CSS
import "../../../css/circle-loader.css";

class CircleLoader extends React.PureComponent {
	render() {
		return <div className="circle-loader" />;
	}
}

export default CircleLoader;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/CircleLoader.js